import { styled } from '@mui/material/styles';

export const FormStyled = styled('div')(({ theme }) => ({
  '& .form-field': {
    width: '100%'
  },
  '& .MuiFormLabel-root.Mui-required': {
    color: theme.palette.primary.light
  }
}));
